import AnimatedArrow from './AnimatedArrow'
export default AnimatedArrow



// WEBPACK FOOTER //
// ./src/Components/Icons/AnimatedArrow/index.js